<template>
  <div :class="[this.$route.name !== 'miniapp-tradingview' ? 'main-mini-app' : null]">
    <dialog-terms-and-condition v-if="!termsAndCondition && isLoginAndAccept === false"></dialog-terms-and-condition>
    <transition :name="fagTransition" mode="out-in" @after-leave="$root.$emit('triggerScroll')">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
    <footer-menu />
    <toast
      v-if="isClientOutside"
      :toggleToast="isClientOutside"
      :options="options"
      toastType="dialog"
      :action="openLineLiff"
    ></toast>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import { DialogTermsAndCondition } from "../../components/organisms"
import { openModalTermsAndConditions } from "../../utils/data-layer"

export default {
  components: {
    FooterMenu: () => import("../../components/miniapp/global/FooterMenu"),
    Toast: () => import("../../components/miniapp/global/Toast"),
    DialogTermsAndCondition
  },
  props: {
    userID: {
      type: String
    }
  },
  data() {
    return {
      options: {
        dialog: {},
        isFullscreen: true
      },
      isLoginAndAccept: false
    }
  },
  watch: {
    getIslogin: {
      immediate: true,
      async handler(val) {
        if (val) {
          // check terms condition status after login
          const status = await this.fetchTermsAndCondition()
          if (status === true) this.isLoginAndAccept = status
          else if (status === false && this.getPDPA.termsandcondition) {
            await this.updateTermsAndCondition({
              status: this.getPDPA.termsandcondition
            })
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters("onboarding", ["getUserSetting", "getPDPA"]),
    ...mapGetters("auth", ["getIslogin"]),
    termsAndCondition() {
      if (this.getPDPA.termsandcondition === false) openModalTermsAndConditions()
      return this.getPDPA.termsandcondition
    },
    isClientOutside() {
      if (
        process.env.NODE_ENV === "production" &&
        process.env.VUE_APP_CONFIG_UNIVERSAL_LINK === "true" &&
        this.$liff.getOS() == "web"
      ) {
        if (this.$liff.isInClient() === false) {
          // is open app outside line application
          document.documentElement.style.overflow = "hidden"
          return true
        }
        // is open app inside line application
        document.documentElement.style.overflow = ""
        return false
      }
      return false
    },
    fagTransition() {
      return this.$route.name === "miniapp-market-lotto" || this.$route.name === "miniapp-market-crypto"
        ? ""
        : "fade-slide-up"
    }
  },
  created() {
    this.setWording()
  },
  mounted() {
    document.documentElement.setAttribute("data-theme", this.getUserSetting.theme)
  },
  methods: {
    ...mapActions("pdpa", ["fetchTermsAndCondition", "updateTermsAndCondition"]),
    setWording() {
      // set wording to universal dialog
      if (this.$liff.getOS() == "web") {
        this.options.dialog.title = `ใช้บริการได้ที่ LINE บนสมาร์ทโฟนหรือแท็บเล็ต`
        this.options.dialog.body = `โปรดเปิดแอพ LINE <br> บนสมาร์ทโฟนหรือแท็บเล็ตแล้วใช้กล้องสแกนคิวอาร์โค้ดด้านล่างเพื่อใช้บริการนี้`
        this.options.valueQR = process.env.VUE_APP_UNIVERSAL_LINK
      }
    },
    openLineLiff() {
      try {
        this.$liff.openWindow({
          url: process.env.VUE_APP_UNIVERSAL_LINK,
          external: true
        })
      } catch (err) {
        window.open(process.env.VUE_APP_UNIVERSAL_LINK)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-mini-app {
  padding-bottom: 70px;
}
</style>